import type { Translations } from '../../../types'

const profileContactMessages: Translations = {
  "profile.contact.loading": "Caricamento…",
  "profile.contact.sectionLabel": "Profilo",
  "profile.contact.sectionTitle": "Identità account",
  "profile.contact.sectionSubtitle": "Gestisci identità e informazioni personali del tuo account.",
  "profile.contact.save": "Salva sezione",
  "profile.contact.saving": "Salvataggio...",
  "profile.contact.firstName.label": "Nome",
  "profile.contact.firstName.placeholder": "Es. Mario",
  "profile.contact.lastName.label": "Cognome",
  "profile.contact.lastName.placeholder": "Es. Rossi",
  "profile.contact.displayName.label": "Nome visualizzato",
  "profile.contact.displayName.placeholder": "Es. Ivan",
  "profile.contact.role.label": "Ruolo / Titolo",
  "profile.contact.role.placeholder": "Es. Head of Ops",
  "profile.contact.email.label": "Email",
  "profile.contact.email.edit": "Modifica email",
  "profile.contact.email.change": "Cambia email",
  "profile.contact.email.cardLabel": "Email account",
  "profile.contact.email.verified": "Verificata",
  "profile.contact.email.placeholder": "es. admin@azienda.it",
  "profile.contact.email.note": "Modificare l'email richiede una conferma di sicurezza.",
  "profile.contact.emailFlow.helper": "Le richieste di cambio email vengono confermate dal nuovo indirizzo.",
  "profile.contact.emailFlow.pending.badge": "Verifica in corso",
  "profile.contact.emailFlow.pending.label": "Verifica richiesta per",
  "profile.contact.emailFlow.pending.description": "Controlla la casella del nuovo indirizzo per completare la conferma.",
  "profile.contact.emailFlow.pending.requestedAt": "Richiesta inviata",
  "profile.contact.emailFlow.pending.resend": "Reinvia email",
  "profile.contact.emailFlow.pending.cancel": "Annulla modifica",
  "profile.contact.emailFlow.modal.title": "Cambia email account",
  "profile.contact.emailFlow.modal.subtitle": "Conferma password e nuovo indirizzo per avviare la verifica email.",
  "profile.contact.emailFlow.modal.currentEmail": "Email attuale",
  "profile.contact.emailFlow.modal.newEmail": "Nuova email",
  "profile.contact.emailFlow.modal.newEmailPlaceholder": "es. nuova-email@azienda.it",
  "profile.contact.emailFlow.modal.password": "Password account",
  "profile.contact.emailFlow.modal.cancel": "Annulla",
  "profile.contact.emailFlow.modal.submit": "Continua",
  "profile.contact.emailFlow.modal.submitting": "Verifica in corso...",
  "profile.contact.emailFlow.error.invalidEmail": "Inserisci un indirizzo email valido.",
  "profile.contact.emailFlow.error.sameEmail": "La nuova email coincide con quella attuale.",
  "profile.contact.emailFlow.error.passwordRequired": "Inserisci la password del tuo account.",
  "profile.contact.emailFlow.error.invalidPassword": "Password non valida.",
  "profile.contact.emailFlow.error.generic": "Impossibile avviare la richiesta di cambio email.",
  "profile.contact.emailFlow.toast.requested": "Richiesta di cambio email avviata.",
  "profile.contact.emailFlow.toast.resent": "Email di conferma inviata di nuovo.",
  "profile.contact.emailFlow.toast.cancelled": "Richiesta di cambio email annullata.",
  "profile.contact.phone.label": "Telefono",
  "profile.contact.phone.placeholder": "+39 02 1234567",
  "profile.contact.locale.label": "Lingua",
  "profile.contact.locale.placeholder": "es. it-IT",
  "profile.contact.taxCode.label": "Codice fiscale",
  "profile.contact.taxCode.placeholder": "RSSMRA85M01H501Z",
  "profile.contact.addresses.title": "Indirizzi cliente",
  "profile.contact.addresses.description": "Gestisci gli indirizzi usati per fatturazione e spedizione.",
  "profile.contact.residentialAddress.label": "Indirizzo di residenza",
  "profile.contact.residentialAddress.placeholder": "Via Roma 10, 20100 Milano (MI), Italia",
  "profile.contact.billingAddress.label": "Indirizzo di fatturazione",
  "profile.contact.billingAddress.placeholder": "Inserisci indirizzo completo per fatturazione",
  "profile.contact.shippingAddress.label": "Indirizzo di spedizione",
  "profile.contact.shippingAddress.placeholder": "Inserisci indirizzo completo per spedizione",
  "profile.contact.bio.label": "Biografia",
  "profile.contact.bio.placeholder": "Racconta in breve chi sei e di cosa ti occupi.",
  "profile.contact.bio.helper": "Racconta in breve chi sei e di cosa ti occupi.",
  "profile.contact.photo.title": "Foto profilo",
  "profile.contact.photo.helper": "Carica un’immagine quadrata. Consigliato 160×160px.",
  "profile.contact.website.label": "Website o social",
  "profile.contact.website.placeholder": "https://tuosito.it",
  "profile.contact.website.helper": "Es. https://tuosito.it o il link al tuo profilo social.",
  "profile.contact.emailDialog.title": "Modifica email",
  "profile.contact.emailDialog.description": "Per cambiare l'email è necessaria una verifica. Riceverai una conferma al nuovo indirizzo. Vuoi procedere?",
  "profile.contact.emailDialog.cancel": "Annulla",
  "profile.contact.emailDialog.confirm": "Procedi",
  "profile.contact.upload.error": "Impossibile caricare l'immagine.",
  "profile.contact.upload.success": "Foto profilo caricata.",
  "profile.contact.upload.failed": "Upload non riuscito.",
  "profile.contact.upload.typeError": "Solo immagini JPG/PNG.",
  "profile.contact.upload.drag": "Trascina qui una nuova foto",
  "profile.contact.upload.pick": "Scegli dal computer",
  "profile.contact.upload.formats": "Formati supportati: JPG, PNG. Dimensione max 2MB.",
  "profile.contact.photo.aria": "Carica foto profilo",
  "profile.contact.photo.previewAlt": "Anteprima avatar",
  "profile.contact.photo.placeholder": "Avatar",
  "profile.account.overview.eyebrow": "Dashboard account",
  "profile.account.overview.subtitle": "Gestisci le informazioni principali del tuo profilo amministratore.",
  "profile.account.overview.accountStatus": "Stato account",
  "profile.account.overview.accountActive": "Account attivo",
  "profile.account.overview.lastAccess": "Ultimo accesso",
  "profile.account.overview.security": "Stato sicurezza",
  "profile.account.overview.securityProtected": "Protezione attiva",
  "profile.account.overview.securityReview": "Da rivedere",
  "profile.account.overview.role": "Ruolo",
  "profile.account.overview.passkeys": "{{count}} passkey",
  "profile.account.overview.passkeysEmpty": "Nessuna passkey",
  "profile.account.overview.editSecurity": "Modifica sicurezza",
  "profile.account.overview.save": "Salva modifiche",
  "profile.account.overview.saving": "Salvataggio...",
  "profile.account.details.eyebrow": "Dati profilo",
  "profile.account.details.title": "Informazioni profilo",
  "profile.account.details.subtitle": "Una vista pulita con i campi principali e i dettagli avanzati sotto.",
  "profile.account.details.save": "Salva profilo",
  "profile.account.details.advanced.title": "Campi avanzati",
  "profile.account.details.advanced.subtitle": "Raccolti qui per tenere la pagina più pulita.",
  "profile.account.summary.title": "Riepilogo account",
  "profile.account.summary.accountStatus": "Stato account",
  "profile.account.summary.securityStatus": "Sicurezza",
  "profile.account.summary.passkeys": "Passkey",
  "profile.account.summary.sessions": "Sessioni",
  "profile.account.summary.sessionsValue": "{{count}} attive",
  "profile.account.quickActions.title": "Azioni rapide",
  "profile.account.quickActions.subtitle": "Accesso veloce alle aree più usate.",
  "profile.account.quickActions.security": "Apri sicurezza",
  "profile.account.quickActions.sessions": "Apri sessioni",
  "profile.account.quickActions.logout": "Esci",
  "profile.account.sensitive.eyebrow": "Operazioni sensibili",
  "profile.account.sensitive.title": "Azioni ad alto impatto",
  "profile.account.sensitive.subtitle": "Le azioni distruttive restano separate e richiedono conferme dedicate.",
  "profile.account.sensitive.exportData": "Esporta dati",
  "profile.account.sensitive.deleteAccount": "Elimina account",
  "profile.account.sensitive.comingSoon": "Disponibile a breve",
  "profile.account.sensitive.notifications": "Disattiva comunicazioni",
  "profile.account.sensitive.reset": "Ripristina preferenze",
  "profile.account.modals.password.title": "Cambia password",
  "profile.account.modals.password.description": "Scegli una password sicura per proteggere il tuo account",
  "profile.account.modals.password.confirmLabel": "Conferma password",
  "profile.account.modals.password.cta": "Aggiorna password",
  "profile.account.modals.password.strength.weak": "Weak",
  "profile.account.modals.password.strength.medium": "Medium",
  "profile.account.modals.password.strength.strong": "Strong",
  "profile.account.modals.password.requirements.length": "Almeno 8 caratteri",
  "profile.account.modals.password.requirements.uppercase": "Una maiuscola",
  "profile.account.modals.password.requirements.number": "Un numero",
  "profile.account.modals.password.requirements.symbolOptional": "Un simbolo (opzionale)",
  "profile.account.modals.password.error.currentRequired": "Inserisci la password attuale.",
  "profile.account.modals.password.error.newRequired": "Inserisci una nuova password.",
  "profile.account.modals.password.error.confirmRequired": "Conferma la nuova password.",
  "profile.account.modals.password.error.mismatch": "Le password non coincidono.",
  "profile.account.modals.password.error.weak": "La password non soddisfa i requisiti minimi.",
  "profile.account.modals.passkey.title": "Aggiungi passkey",
  "profile.account.modals.passkey.description": "Usa Face ID, Touch ID o dispositivo sicuro",
  "profile.account.modals.passkey.continue": "Continua",
  "profile.account.modals.twoFactor.title": "Gestisci 2FA",
  "profile.account.form.title": "Dati personali",
  "profile.account.form.subtitle": "Aggiorna i tuoi dati personali e le preferenze del tuo account.",
  "profile.account.photo.title": "Foto profilo",
  "profile.account.photo.subtitle": "Avatar compatto per dashboard e commenti operativi.",
  "profile.account.photo.upload": "Carica",
  "profile.account.photo.replace": "Sostituisci",
  "profile.account.photo.remove": "Rimuovi",
  "profile.account.security.title": "Sicurezza account",
  "profile.account.security.subtitle": "Proteggi l'accesso al backoffice con impostazioni di sicurezza avanzate.",
  "profile.account.security.eyebrow": "Sicurezza",
  "profile.account.security.manageSecurity": "Gestisci sicurezza",
  "profile.account.security.emailStatus": "Stato email",
  "profile.account.security.emailStatusActive": "Email di accesso attiva",
  "profile.account.security.lastAccess": "Ultimo accesso",
  "profile.account.security.password": "Password",
  "profile.account.security.twoFactor": "2FA",
  "profile.account.security.passkeys": "Passkey",
  "profile.account.security.passkeysValue": "{{count}} configurate",
  "profile.account.security.passkeysEmpty": "Nessuna configurata",
  "profile.account.security.sessions": "Sessioni",
  "profile.account.security.sessionsValue": "{{count}} attive",
  "profile.account.security.changePassword": "Cambia password",
  "profile.account.security.manageTwoFactor": "Gestisci 2FA",
  "profile.account.security.managePasskeys": "Gestisci passkey",
  "profile.account.security.manageSessions": "Sessioni",
  "profile.account.security.helper": "Ultimo accesso: {{lastAccess}} · IP: {{ip}}",
  "profile.account.sessions.eyebrow": "Sessioni",
  "profile.account.sessions.title": "Sessioni attive",
  "profile.account.sessions.subtitle": "Controlla gli accessi recenti e i dispositivi collegati.",
  "profile.account.sessions.manage": "Gestisci sessioni",
  "profile.account.sessions.empty": "Nessuna sessione trovata.",
  "profile.account.sessions.unknownDevice": "Dispositivo sconosciuto",
  "profile.account.sessions.current": "Corrente",
  "profile.account.sessions.currentHint": "Questa è la sessione attiva su questo dispositivo.",
  "profile.account.role.title": "Ruolo e accessi",
  "profile.account.role.subtitle": "Permessi e livello operativo del tuo account.",
  "profile.account.role.superAdminBadge": "Super Admin",
  "profile.account.privacy.title": "Privacy e account",
  "profile.account.privacy.subtitle": "Gestisci privacy, esportazione dati e preferenze.",
  "profile.account.privacy.exportData": "Esporta dati",
  "profile.account.privacy.consents": "Consensi",
  "profile.account.privacy.deleteAccount": "Elimina account",
  "profile.account.privacy.communications": "Disattiva comunicazioni",
  "profile.account.privacy.reset": "Ripristina preferenze",
  "profile.account.privacy.comingSoon": "Disponibile a breve",
  "profile.account.privacy.dangerHint": "Le operazioni sensibili richiedono conferma aggiuntiva.",
  "profile.account.activity.title": "Attivita recente",
  "profile.account.activity.subtitle": "Accessi e dispositivi usati di recente.",
  "profile.account.activity.empty": "Nessuna attivita recente disponibile.",
  "profile.account.activity.device": "Dispositivo",
  "profile.account.activity.current": "Sessione corrente",
  "profile.addresses.sectionLabel": "Account cliente",
  "profile.addresses.sectionTitle": "Indirizzi e fatturazione",
  "profile.addresses.sectionSubtitle": "Gestisci in modo rapido indirizzi di spedizione e fatturazione con una pagina dedicata desktop.",
  "profile.addresses.save": "Salva indirizzi",
  "profile.addresses.saving": "Salvataggio...",
  "profile.addresses.residentialAddress.label": "Indirizzo di residenza",
  "profile.addresses.residentialAddress.placeholder": "Via Roma 10, 20100 Milano (MI), Italia",
  "profile.addresses.residentialAddress.helper": "Usato come riferimento anagrafico principale del profilo cliente.",
  "profile.addresses.billingAddress.label": "Indirizzo di fatturazione",
  "profile.addresses.billingAddress.placeholder": "Inserisci indirizzo completo per fatturazione",
  "profile.addresses.shippingAddress.label": "Indirizzo di spedizione",
  "profile.addresses.shippingAddress.placeholder": "Inserisci indirizzo completo per spedizione",
  "profile.addresses.residential.title": "Indirizzo di residenza",
  "profile.addresses.residential.subtitle": "Gestisci l'indirizzo anagrafico principale del tuo account.",
  "profile.addresses.shipping.title": "Indirizzi di spedizione",
  "profile.addresses.shipping.subtitle": "Gestisci gli indirizzi usati per consegna ordini.",
  "profile.addresses.billing.title": "Indirizzi di fatturazione",
  "profile.addresses.billing.subtitle": "Gestisci gli indirizzi usati per documenti fiscali e fatture.",
  "profile.addresses.addAddress": "Aggiungi nuovo indirizzo",
  "profile.addresses.actions.editResidential": "Modifica indirizzo",
  "profile.addresses.empty.title": "Nessun indirizzo salvato",
  "profile.addresses.empty.subtitle": "Aggiungi un indirizzo per semplificare checkout e gestione ordini.",
  "profile.addresses.legacyAddressLabel": "Indirizzo salvato",
  "profile.addresses.card.untitled": "Indirizzo senza etichetta",
  "profile.addresses.card.defaultBadge": "Predefinito",
  "profile.addresses.card.edit": "Modifica",
  "profile.addresses.card.delete": "Elimina",
  "profile.addresses.card.setDefault": "Imposta come predefinito",
  "profile.addresses.card.intercom": "Citofono: {{value}}",
  "profile.addresses.card.phone": "Telefono: {{value}}",
  "profile.addresses.card.taxReference": "Riferimento fiscale: {{value}}",
  "profile.addresses.modal.createTitle": "Aggiungi indirizzo · {{type}}",
  "profile.addresses.modal.editTitle": "Modifica indirizzo · {{type}}",
  "profile.addresses.modal.subtitle": "Compila i campi dell'indirizzo. Puoi impostare l'indirizzo come predefinito.",
  "profile.addresses.modal.cancel": "Annulla",
  "profile.addresses.modal.saveCreate": "Salva indirizzo",
  "profile.addresses.modal.saveEdit": "Aggiorna indirizzo",
  "profile.addresses.deleteDialog.title": "Conferma eliminazione",
  "profile.addresses.deleteDialog.description": "Vuoi eliminare l'indirizzo \"{{label}}\"?",
  "profile.addresses.deleteDialog.defaultDescription": "Stai eliminando l'indirizzo predefinito \"{{label}}\". Verrà selezionato automaticamente un altro indirizzo.",
  "profile.addresses.deleteDialog.blockedDescription": "Questo è l'ultimo indirizzo salvato. Aggiungine prima uno nuovo per poter procedere.",
  "profile.addresses.deleteDialog.cancel": "Annulla",
  "profile.addresses.deleteDialog.confirm": "Elimina indirizzo",
  "profile.addresses.deleteDialog.addNew": "Aggiungi nuovo indirizzo",
  "profile.addresses.fields.label": "Etichetta indirizzo",
  "profile.addresses.fields.labelPlaceholder": "Es. Casa, Ufficio, Magazzino",
  "profile.addresses.fields.recipientName": "Nome destinatario",
  "profile.addresses.fields.recipientNamePlaceholder": "Es. Mario Rossi",
  "profile.addresses.fields.intercomName": "Nome sul citofono",
  "profile.addresses.fields.intercomNamePlaceholder": "Es. Rossi / 2B",
  "profile.addresses.fields.phone": "Telefono di riferimento",
  "profile.addresses.fields.phonePlaceholder": "+39 333 1234567",
  "profile.addresses.fields.companyName": "Azienda (opzionale)",
  "profile.addresses.fields.companyNamePlaceholder": "Es. Emporion Srl",
  "profile.addresses.fields.taxReference": "Codice fiscale / Partita IVA",
  "profile.addresses.fields.taxReferencePlaceholder": "Es. RSSMRA85M01H501Z / IT12345678901",
  "profile.addresses.fields.line1": "Via / Piazza",
  "profile.addresses.fields.line1Placeholder": "Es. Via Roma",
  "profile.addresses.fields.houseNumber": "Numero civico",
  "profile.addresses.fields.houseNumberPlaceholder": "Es. 24A",
  "profile.addresses.fields.line2": "Interno / Scala / Piano",
  "profile.addresses.fields.line2Placeholder": "Es. Scala B, Piano 3, Interno 7",
  "profile.addresses.fields.postalCode": "CAP",
  "profile.addresses.fields.postalCodePlaceholder": "Es. 00100",
  "profile.addresses.fields.city": "Città",
  "profile.addresses.fields.cityPlaceholder": "Es. Roma",
  "profile.addresses.fields.province": "Provincia / Stato",
  "profile.addresses.fields.provincePlaceholder": "Es. RM / Lazio",
  "profile.addresses.fields.country": "Paese",
  "profile.addresses.fields.countryPlaceholder": "Es. Italia",
  "profile.addresses.fields.notes": "Note consegna",
  "profile.addresses.fields.notesPlaceholder": "Informazioni utili per corriere o fatturazione.",
  "profile.addresses.fields.isDefault": "Imposta come indirizzo predefinito",
  "profile.addresses.validation.required": "Campo obbligatorio."
}

export default profileContactMessages
